function ProgItemController(PackageService) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.isNavCollapsed = true;
  };

  ctrl.$onChanges = changes => {
    if (changes.data) {
      if (ctrl.data.phase === 'cancelled') {
        ctrl.cancelling = false;
      }
    }
  };

  ctrl.cancelUpload = progressObject => {
    ctrl.cancelling = true;
    PackageService.abortUpload(ctrl.consist, progressObject.id).then(
      response => {
        // toasterService.success('toaster.package-upload-event', 'toaster.package-upload-start-success');
      },
      err => {
        // toasterService.error('toaster.package-upload-event', 'toaster.package-upload-start-failure');
        console.error(err);
      }
    );
  };

  ctrl.dismissUpload = progressObject => {
    PackageService.dismissUpload(progressObject.id).then(
        e => {
          console.error(e);
        }
    );
  };
}

angular
  .module('configuration-management.module')
  .controller('ProgItemController', ProgItemController);
